
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { make, getServerSideProps } from '../components/pages/forgotEmailAddress/ForgotEmailAddress.bs';

export { make as default, getServerSideProps };
